import { z } from 'zod'

export const MEMBERSHIP_SCIM_SYNTHETIC_PROOF_CONTRACT_VERSION = '1.0.0' as const

export const membershipScimSyntheticProofResponseSchema = z.record(z.unknown())

export type MembershipScimSyntheticProofResponse = z.infer<typeof membershipScimSyntheticProofResponseSchema>
